import Vue from 'vue';
// import Vuetify from 'vuetify';
import VueAuth from '@websanova/vue-auth';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueTheMask from 'vue-the-mask';
import VeeValidate, { Validator } from 'vee-validate';
import moment from 'moment';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import de from 'vee-validate/dist/locale/de';
import it from 'vee-validate/dist/locale/it';
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import VueGtm from 'vue-gtm';
import i18n from './i18n';
// import './stylus/custom.styl';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import router from './router/router';
import store from './store/store';
import auth from './auth';
import './helpers/filters';
import Loader from './components/_molecules/Loader.vue';

Vue.config.productionTip = false;
Vue.config.devtools = process.env.VUE_APP_ENVIRONMENT !== 'prod';

if (process.env.VUE_APP_ENVIRONMENT !== 'local') {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    autoSessionTracking: true,
    integrations: [
      new Integrations.BrowserTracing(),
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}

// Axios
Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_BACKEND_API;

Vue.router = router;
Vue.use(VueGtm, {
  enabled: process.env.VUE_APP_ENVIRONMENT === 'prod',
  debug: false, // Whether or not display console logs debugs (optional)
  vueRouter: router,
  id: 'GTM-N3K36VX',
  // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'],
  // If router, you can exclude some routes name (case insensitive) (optional)
});

Vue.use(VueAuth, auth);

// Axios Configuration
axios.interceptors.request.use((config) => {
  const axiosConfig = config;
  axiosConfig.baseURL = process.env.VUE_APP_BACKEND_API;
  // if (process.env.VUE_APP_ENVIRONMENT === 'local') {
  //   axiosConfig.url = `${config.url}?XDEBUG_SESSION_START=PHPSTORM`;
  // }
  return axiosConfig;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 400 && error.response.data && error.response.data.error === 'token_expired') {
      Vue.auth.logout({
        makeRequest: false,
        redirect: `/${i18n.locale}`,
      });
    }
    return Promise.reject(error);
  },
);

Vue.use(VueTheMask);

Vue.use(VeeValidate, {
  errorBagName: 'errors',
  locale: store.state.user.language,
  inject: false,
});
Validator.localize('de', de);
Validator.localize('it', it);
Validator.localize(store.state.user.language);

VeeValidate.Validator.extend('verify_password', {
  getMessage: () => i18n.t('validation.password_strength'),
  validate: (value) => {
    const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_+-?)(.,)])(?=.{8,})');
    return strongRegex.test(value);
  },
});

VeeValidate.Validator.extend('season', {
  getMessage: () => i18n.t('texts.maxDurationSeasonJobInfo'),
  validate: (value, [otherValue]) => {
    const start = moment(otherValue);
    const end = moment(value);
    return end.diff(start, 'months') <= 9;
  },
}, {
  hasTarget: true,
});

VeeValidate.Validator.extend('infuture', {
  getMessage: () => i18n.t('texts.mustBeInFuture'),
  validate: (value) => {
    const today = moment();
    const end = moment(value);
    return end.diff(today, 'months') >= 0;
  },
}, {
  hasTarget: true,
});

Vue.use(VueQuillEditor);

const EventBus = new Vue();
Object.defineProperties(Vue.prototype, {
  $eventBus: {
    get: () => EventBus,
  },
});

Vue.prototype.moment = moment;
Vue.component('loader', Loader);

// Vue.use(Vuetify, {
//   iconfont: 'mdi',
// });

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
